import type { SchemaOf } from '../helpers';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';
import type { Revision } from '../configuration';
import { revisionSchema } from '../configuration';

const recordParamsSchemaMap: SchemaOf<IRecordParams> = {
  conversationId: Joi.string().required(),
  consoleId: Joi.string().required(),
  organisationId: Joi.string().required(),
  shouldSendMessage: Joi.boolean().required(),
  consoleVersion: Joi.string().required(),
  configRevision: revisionSchema,
};

export const recordParamsSchema = Joi.object(recordParamsSchemaMap).pattern(
  /debug.+/,
  Joi.any()
);

export interface IRecordParams {
  conversationId: string;
  consoleId: string;
  organisationId: string;
  shouldSendMessage: boolean;
  consoleVersion: string;
  configRevision: Revision;
}

export const RECORD = 'VOICE_TO_TEXT/RECORD';

export const recordActionSchema = objectSchemaOf<IRecordAction>({
  type: Joi.string().required().valid(RECORD),
  payload: recordParamsSchema.required(),
});

export interface IRecordAction {
  type: typeof RECORD;
  payload: IRecordParams;
}

export const record = actionCreator({
  type: RECORD,
  schema: recordActionSchema,
});
